<template>
  <div class="relative grid gap-2">
    <div class="absolute z-10 top-1 right-2 text-2xs opacity-20 text-white" v-html="`${position}`" />
    <div class="w-full bg-black relative rounded overflow-hidden">
      <div class="absolute z-10 bottom-0 left-0 w-full p-3 md:p-4 grid gap-3">
        <div class="relative z-10 w-24 h-12 invert" v-if="restaurant.logo">
          <AtomImage class="h-full !object-contain object-left-bottom" :src="useCloudinaryImage(restaurant.logo, 300, null, 'fit,e_trim')" :alt="restaurant.name" />
        </div>
        <div class="relative z-10 flex items-center gap-2" v-if="featuredTags.length">
          <div class="text-sm whitespace-nowrap text-[#DBDBDB] border border-[#888888]/80 bg-black/10 rounded px-2 py-0.5" v-for="tag in featuredTags" :key="tag.id">
            {{ tag.label }}
          </div>
        </div>
        <div class="!text-white text-sm relative z-10">
          <AtomRestaurantLocation 
            :name="restaurant.name" 
            :address="[restaurant.address, restaurant.city].join(', ')"
          />
        </div>
        <div class="absolute bottom-0 left-0 w-full h-full bg-gradient-to-t from-25% from-black/80"></div>
      </div>
      <div class="aspect-video sm:aspect-4/3 md:aspect-square">
        <AtomImage class="!object-cover" :src="useCloudinaryImage(restaurant.cover, 400, 400)" :alt="restaurant.name" />
      </div>
    </div>
  </div>
</template>

<script setup>
const props = defineProps({
  restaurant: {
    type: Object,
    default: () => {}
  },
  position: {
    type: Number,
    default: 0
  }
})

const featuredTags = computed(() => useFeaturedTags(props.restaurant.tags, 3))
</script>